import algoliasearch from "algoliasearch";
import localforage from "localforage";
import aa from "search-insights";

const algoliaApplicationId = document.querySelector('meta[name="algolia-application-id"]').content;
const algoliaSearchKey = document.querySelector('meta[name="algolia-search-key"]').content;
const algoliaUserToken = document.querySelector('meta[name="algolia-user-token"]').content;
const algolia = algoliasearch(algoliaApplicationId, algoliaSearchKey);
const indexPrefix = document.querySelector('meta[name="algolia-prefix"]').content;
const algoliaIndex = algolia.initIndex(`${indexPrefix}_combined`);
aa('init', {
    appId: algoliaApplicationId,
    apiKey: algoliaSearchKey
});
aa('setUserToken', algoliaUserToken);


class Search {
    constructor(container, indexName, algoliaIndex) {
        this._container = container;
        this._indexName = indexName;
        this._form = this._container.querySelector('form');
        this._searchInput = this._container.querySelector('input[type="search"]');
        this._query;
        this._provider = algoliaIndex;
        this._resultsContainer = this._container.querySelector('.results');
        this._recentContainer = this._container.querySelector('.recent');
        this._termsContainer = this._container.querySelector('.terms');
        this._clearTextInput = this._container.querySelector('input[type="reset"]');
        this._clearTextButton = this._container.querySelector('button[type="reset"]');
        this._countContainer = this._container.querySelector('.search-index__count');
        this._paginationContainer = this._container.querySelector('.search-index__pagination');
        this._trendingContentIds = this._container.dataset.trendingids;
        if(this._trendingContentIds) {
            this._trendingContentIds = JSON.parse(this._trendingContentIds);
        }
        this._showUrl = (this._container.dataset.showUrl === 'true');
        this._updateRecentTerms = true;
        this._instant = (this._container.dataset.instant === 'true');
        this._recent = (this._container.dataset.recent === 'true');
        this._filters = (this._container.dataset.filters === 'true');
        this._headerSearch = (this._container.dataset.header === 'true');
        this._initialKeywords = this._container.dataset.initialKeywords;
        this._showPagination = (this._container.dataset.pagination === 'true');
        this._section = this._container.dataset.section;
        this._category = this._container.dataset.category;
        this._page = this._container.dataset.page;
        this._filterString = '';
        this._noResultsMessage = unescape(this._container.dataset.noresultsmsg);

        this._facets = [
            {
                'name':'website',
                'sections': [
                    'pages',
                    'caseStudies',
                    'conceptsPdfDownloads',
                    'webinarsUpcoming',
                    'webinarsOnDemand'
                ],
                'count': 0
            },
            {
                'name':'videos',
                'sections': [
                    'video'
                ],
                'count': 0
            },
            {
                'name':'blog',
                'sections': [
                    'blog'
                ],
                'count': 0
            }
        ];

        localforage.getItem('searchHistory').then((value) => {
            if(value === null) {
                this._searchHistory = [];
                this._updateRecentTerms = false;
            } else {
                this._searchHistory = value;
                this.showRecentHistory();
            }
        });

        this.init();
    }

    init() {
        if(this._resultsContainer === null) {
            return;
        }

        if(!this._page) {
            this._page = 0;
        }

        if(this._initialKeywords !== undefined && this._initialKeywords.length > 0) {
            this.setQueryValue(this._initialKeywords);
            this.queryProvider();
        }

        if(this._filters) {
            this._filtersContainer = this._container.querySelector('.filters');
            this._filtersUl = this._filtersContainer.querySelector('ul');
        }

        if(this._instant) {
            this._searchInput.addEventListener('keyup', () => {
                this.setQueryValue(this._searchInput.value);
            });
            this._searchInput.addEventListener('keypress', (e) => {
                let code = (e.keyCode ? e.keyCode : e.which);
                if(code == 13) {
                    this._form.submit();
                }
            })
        }

        this._searchInput.addEventListener('blur', () => {
            if(this._searchInput.value.length > 3) {
                this.saveSearchHistory();
            }
        });
        if(this._clearTextInput) {
            this._clearTextInput.addEventListener('click', () => {
                this.setQueryValue('');
                this._searchInput.focus();
            });
        }
        if(this._clearTextButton) {
            this._clearTextButton.addEventListener('click', () => {
                this.setQueryValue('');
                this._searchInput.focus();
            });
        }
    }

    setQueryValue(query) {
        this._query = query;
        if(this._query.length > 0) {
            if(this._instant) {
                this.queryProvider();
            }
            this.showClearButtons();
            if(this._headerSearch){
                document.querySelector('.site-header .site-search').classList.add('search-expand');
                this._resultsContainer.classList.add('has-results');
            }
        } else {
            this.clearResultsContainer();
            this.hideClearButtons();
            document.querySelector('.site-header .site-search').classList.remove('search-expand');
            this._resultsContainer.classList.remove('has-results');
        }
    }

    clearResultsContainer() {
        this._resultsContainer.innerHTML = '';
    }

    showClearButtons() {
        if(this._clearTextInput) {
            this._clearTextInput.classList.add('visible');
        }
        if(this._clearTextButton) {
            this._clearTextButton.classList.add('visible');
        }
    }

    hideClearButtons() {
        if(this._clearTextInput) {
            this._clearTextInput.classList.remove('visible');
        }
        if(this._clearTextButton) {
            this._clearTextButton.classList.remove('visible');
        }
    }

    getFilterString() {
        let strings = [];
        for (let index = 0; index < this._facets.length; index++) {
            const element = this._facets[index];
            if(element.name == this._section) {
                element.sections.forEach(s => {
                    strings.push(`section:${s}`);
                })
            }
        }

        let filterString = '';
        if(strings.length > 0) {
            filterString = strings.join(' OR ')
        }
        if(this._category) {
            if(strings.length > 0) {
                filterString = `${filterString} AND related_business_lines:"${this._category}"`;
            } else {
                filterString = `related_business_lines:"${this._category}"`;
            }
        }
        return filterString;
    }

    queryProvider() {
        let page = this._page - 1;
        if(page < 0) {
            page = 0;
        }

        let filterString = '';
        if(this._category) {
            filterString = `related_business_lines:"${this._category}"`;
        }

        if(this._filters) {
            this._provider.search(this._query, {
                hitsPerPage: 10,
                clickAnalytics: true,
                enablePersonalization: true,
                facets: ['section'],
                page: page,
                filters: filterString,
            }).then(({ facets, hitsPerPage, nbHits, nbPages, page, hits }) => {
                this.updateFilters(facets);
            });
        }


        this._provider.search(this._query, {
            hitsPerPage: 10,
            clickAnalytics: true,
            enablePersonalization: true,
            facets: ['section'],
            filters: this.getFilterString(),
            page: page,
          }).then(({ hits, nbPages, queryID, facets, hitsPerPage, nbHits, page }) => {
            this.clearResultsContainer();
            if(hits.length === 0) {
                this._resultsContainer.innerHTML = this._noResultsMessage;
                return;
            }
            hits.forEach((hit, index) => {
                let element = this.generateResultElement(hit, queryID, index);
                this._resultsContainer.append(element);
            })
            if(!this._showPagination && nbPages > 1) {
                let button = document.createElement('a');
                button.classList.add('ash-button');
                button.innerText = 'View All Results';
                button.href = `/search?keywords=${this._query}`;
                this._resultsContainer.append(button);
            }
            this.updatePagination(hitsPerPage, nbHits, nbPages, page, hits);
        });
    }

    generateResultElement(hit, queryID, index) {
        let element = document.createElement('div');
        element.classList.add('result', 'search-result');

        let tagContainer = document.createElement('div')
        tagContainer.classList.add('tag-container');
        element.appendChild(tagContainer);

        let detailContainer = document.createElement('div')
        detailContainer.classList.add('detail-container');
        element.appendChild(detailContainer);


        let header = document.createElement('header');
        let h2 = document.createElement('h2');
        let headerLink = document.createElement('a');
        headerLink.href = hit.url;
        headerLink.innerText = hit.title;

        if(hit.is_gated) {
            let lock = `<svg style="margin-left: 1rem" width="9" height="12" xmlns="http://www.w3.org/2000/svg"><path d="M7.72 4.412h-.367v-1.47A2.944 2.944 0 004.412 0 2.944 2.944 0 001.47 2.941v1.47h-.368C.495 4.412 0 4.907 0 5.516v5.147c0 .608.495 1.103 1.103 1.103H7.72c.607 0 1.103-.495 1.103-1.103V5.515c0-.609-.496-1.103-1.103-1.103zm-5.269-1.47c0-1.082.88-1.962 1.96-1.962 1.082 0 1.962.88 1.962 1.961v1.47H2.45v-1.47zm2.451 5.255v1.117a.49.49 0 11-.98 0V8.197a.977.977 0 01.49-1.824.977.977 0 01.49 1.825z" fill="#C7C7C7" fill-rule="nonzero"/></svg>`
            headerLink.insertAdjacentHTML('beforeend', lock);
        }

        h2.append(headerLink);
        header.append(h2);
        detailContainer.append(header);

        if(typeof this._trendingContentIds === 'object' && this._trendingContentIds.includes(hit.craft_id)) {
            let trendingEl = document.createElement('div');
            trendingEl.classList.add('trending-tag');
            trendingEl.innerText = 'Trending';
            tagContainer.append(trendingEl);
        }

        if(hit.summary) {
            let trimmedSummary = hit.summary.replace(/^(.{150}[^\s]*).*/, "$1");
            if(trimmedSummary !== hit.summary) {
                trimmedSummary = trimmedSummary + '&nbsp;&hellip;'
            }
            let summary = document.createElement('p');
            summary.innerHTML = trimmedSummary;
            detailContainer.append(summary);
        }

        if(this._showUrl) {
            let link = document.createElement('a');
            link.href = hit.url;
            link.innerText = hit.url;
            detailContainer.append(link);
        }

        element.addEventListener('click', (event) => {
            let data = {
                index: this._indexName,
                eventName: 'Click item',
                queryID: queryID,
                objectIDs: [hit.objectID],
                positions: [(index + 1)],
            };
            aa('clickedObjectIDsAfterSearch', data);
        })

        return element;
    }

    saveSearchHistory() {
        this._searchHistory.unshift(this._query);

        let tempHistory = this._searchHistory;
        tempHistory = tempHistory.filter((q, index) => {
            return tempHistory.indexOf(q) === index;
        });
        tempHistory = tempHistory.slice(0, 3);

        this._searchHistory = tempHistory;
        localforage.setItem('searchHistory', this._searchHistory);

        this.showRecentHistory();
    }

    showRecentHistory() {
        if(this._termsContainer && this._updateRecentTerms) {
            this._recentContainer.style.display = 'block';
            this._termsContainer.innerHTML = '';
            this._searchHistory.forEach(term => {
                let termLink = document.createElement('a');
                termLink.innerText = term;
                termLink.href = `/search?keywords=${term}`;
                termLink.classList.add('ash-button', 'outlined', 'small');

                termLink.addEventListener('click', (event) => {
                    event.preventDefault();
                    this.setQueryValue(term);
                    this._searchInput.value = term;
                })

                this._termsContainer.append(termLink);
            })
        }
    }

    updateFilters(facets) {
        let totalCount = 0;
        for (let index = 0; index < this._facets.length; index++) {
            const element = this._facets[index];
            element.count = 0;
        }
        if(facets.section !== undefined) {
            this._filtersContainer.style.display = 'block';
            for (const [key, value] of Object.entries(facets.section)) {
                for (let index = 0; index < this._facets.length; index++) {
                    const element = this._facets[index];
                    if(element.sections.includes(key)) {
                        element.count = element.count + value;
                        totalCount = totalCount + value;
                    }
                }
            }
        }

        let numberOfFacets = 0;
        for (let index = 0; index < this._facets.length; index++) {
            const element = this._facets[index];
            if(element.count > 0) {
                numberOfFacets = numberOfFacets + 1;
            }
        }

        // all filter
        let facetEl = document.createElement('li');
        let facetLink = document.createElement('a');
        let href = `/search?keywords=${this._query}`;
        if(this._category) {
            href = `${href}&category=${this._category}`;
        }
        facetLink.href = href;
        facetLink.innerHTML = `All (${totalCount})`;
        facetEl.append(facetLink);
        this._filtersUl.append(facetEl);

        if(!this._section) {
            facetEl.classList.add('active');
        }

        if(numberOfFacets > 1) {
            for (let index = 0; index < this._facets.length; index++) {
                const element = this._facets[index];
                if( element.count > 0 ) {
                    let facetEl = document.createElement('li');
                    let facetLink = document.createElement('a');
                    let href = `/search?keywords=${this._query}&section=${element.name}`;
                    if(this._category) {
                        href = `${href}&category=${this._category}`;
                    }
                    facetLink.href = href;
                    facetLink.innerHTML = `${element.name} (${element.count})`;
                    facetEl.append(facetLink);
                    if(this._section == element.name) {
                        facetEl.classList.add('active');
                    }
                    this._filtersUl.append(facetEl);
                }
            }
        }

    }

    updatePagination(hitsPerPage, nbHits, nbPages, page, hits) {
        let actualPage = page + 1;

        if(this._countContainer) {
            let resultsStart = 0;
            let resultsEnd = 0;
            if(actualPage == 1) {
                resultsStart = 1;
                resultsEnd = hitsPerPage;
                if(resultsEnd > nbHits) {
                    resultsEnd = nbHits;
                }
            } else {
                resultsEnd = actualPage * hitsPerPage;
                if(resultsEnd > nbHits) {
                    resultsEnd = nbHits;
                }
                resultsStart = resultsEnd - hits.length + 1;
            }
            let countString = `Results ${resultsStart}-${resultsEnd} of ${nbHits}`;
            this._countContainer.innerText = countString;
        }

        if(this._paginationContainer && nbPages > 1) {
            this._paginationContainer.innerHTML = '';

            let paginationUl = document.createElement('ul');
            let paginationPages = this.pagination((page + 1), nbPages);
            paginationPages.forEach(pp => {
                let pageLi = document.createElement('li');
                let pageItem;
                if (typeof pp === 'number' && pp != (page + 1)) {
                    pageItem = document.createElement('a');
                    let href = `/search?keywords=${this._query}`;
                    if(this._category) {
                        href = `${href}&category=${this._category}`;
                    }
                    if(this._section) {
                        href = `${href}&section=${this._section}`;
                    }
                    if(pp > 1) {
                        href = `${href}&page=${pp}`
                    }
                    pageItem.href = href;
                } else {
                    pageItem = document.createElement('span');
                }
                pageItem.innerText = pp;
                pageLi.append(pageItem);
                paginationUl.append(pageLi);
            });

            this._paginationContainer.append(paginationUl);
        }
    }

    pagination(current, total) {
        const center = [current - 3, current - 2, current - 1, current, current + 1, current + 2, current + 3],
            filteredCenter = center.filter((p) => p > 1 && p < total),
            includeThreeLeft = current === 5,
            includeThreeRight = current === total - 4,
            includeLeftDots = current > 5,
            includeRightDots = current < total - 4;

        if (includeThreeLeft) filteredCenter.unshift(2)
        if (includeThreeRight) filteredCenter.push(total - 1)

        if (includeLeftDots) filteredCenter.unshift('...');
        if (includeRightDots) filteredCenter.push('...');

        return [1, ...filteredCenter, total]
    }

}

Array.from(document.querySelectorAll('[data-algolia]')).forEach(el => new Search(el, `${indexPrefix}_combined`, algoliaIndex));